import axios from "axios";
import { Global } from '../utils/general';
import headerRequest from "../utils/headers"

const API_URL = Global.url;

const NotificationConfigService = {
    // Get all notification configs
    getConfigs: (userId) => {
        const ruta = `${API_URL}/notification-config`;
        const params = userId ? { usuario_id: userId } : {};
        return axios.get(ruta, {
            params: params,
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    },

    // Get specific config by id
    getConfigById: (id) => {
        const ruta = `${API_URL}/notification-config/${id}`;
        return axios.get(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    },

    // Create new config
    createConfig: (data) => {
        const ruta = `${API_URL}/notification-config`;
        return axios.post(ruta, data, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    },

    // Update config
    updateConfig: (id, data) => {
        const ruta = `${API_URL}/notification-config/${id}`;
        return axios.patch(ruta, data, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    },

    // Delete config
    deleteConfig: (id) => {
        const ruta = `${API_URL}/notification-config/${id}`;
        return axios.delete(ruta, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    },

    // Toggle config enabled/disabled
    toggleConfig: (id) => {
        const ruta = `${API_URL}/notification-config/${id}/toggle`;
        return axios.patch(ruta, {}, {
            headers: headerRequest(),
        }).catch((error) => {
            return error;
        });
    }
};

export default NotificationConfigService;
